import AbstractValidator from './abstractValidator';
import StrategyInterface from './itemHeightStrategy/strategyInterface';

/**
 * @class ItemHeightValidator
 * @extends AbstractValidator
 */
export default class ItemHeightValidator extends AbstractValidator {
    /**
     * @param {ProblemFactory} problemFactory
     * @param {StrategyInterface} strategy
     * @param {string} message
     */
    constructor(problemFactory, strategy, message) {
        super(problemFactory);
        StrategyInterface.assert(strategy);

        this.strategy = strategy;
        this.message = message;
    }

    _isItemSupported(item) {
        return item.supportsMaxHeight;
    }

    _isItemValid(item) {
        return this.strategy.checkItemDepth(item);
    }

    _createProblems(item) {
        return [this.problemFactory.createError('itemHeight', this.message, 'bag-depth', [item])];
    }
}
